import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const LogInRoute = ({ component: Component, logedIn, ...rest }) => {
  if (logedIn) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  return <Redirect from="*" to="/login" />;
};

export default LogInRoute;



// WEBPACK FOOTER //
// ./src/Components/Common/LogInRoute.jsx